import React from "react";
import PropTypes from "prop-types";
import { Grid, Button } from "semantic-ui-react";

const DashboardButton = ({
  buttonKey,
  label,
  activeDashboardSection,
  handleButtonClick,
  handleTabNavigation
}) => {
  const BUTTON_FOCUS_STYLE = {
    outline: "2px solid #0078d4",
    outlineOffset: "2px"
  };

  const BUTTON_BLUR_STYLE = {
    outline: "",
    outlineOffset: ""
  };

  const handleButtonFocus = e => {
    Object.assign(e.target.style, BUTTON_FOCUS_STYLE);
  };

  const handleButtonBlur = e => {
    Object.assign(e.target.style, BUTTON_BLUR_STYLE);
  };

  return (
    <Grid.Column width={4}>
      <Button
        style={{ fontSize: "18px" }}
        active={activeDashboardSection === buttonKey}
        fluid
        role="tab"
        tabIndex={activeDashboardSection === buttonKey ? 0 : -1}
        aria-selected={activeDashboardSection === buttonKey}
        aria-controls={`${buttonKey}-panel`}
        id={`${buttonKey}-tab`}
        onClick={() => handleButtonClick(buttonKey)}
        onKeyDown={e => handleTabNavigation(e)}
        onFocus={handleButtonFocus}
        onBlur={handleButtonBlur}
      >
        {label}
      </Button>
    </Grid.Column>
  );
};

DashboardButton.propTypes = {
  buttonKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  activeDashboardSection: PropTypes.string.isRequired,
  handleButtonClick: PropTypes.func.isRequired,
  handleTabNavigation: PropTypes.func.isRequired
};

export default DashboardButton;
